import { parseISO, startOfDay } from "date-fns";

// BE may send either "YYYY-MM-DD" or a full ISO instant with timezone.
// `startOfDay` aligns both into the user's local calendar day so
// `differenceInCalendarDays` matches what the user sees on their device
// (e.g. an instant `2026-05-13T22:00:00Z` is May 14 in Europe/Prague).
export const parseTimelineDate = (isoDate: string): Date =>
	startOfDay(parseISO(isoDate));
